import React from 'react';
//import ProductItem from './children/ProductItem';
import PrescriptionItem from './children/PrescriptionItem';

const PharmacyOrderItemsList = (props) => {
    const {prescriptions, products, prices,partial_offer_id} = props.order;
    return (
        <div className="lab-order-items-list">
            {
                prescriptions.map((prescription, index) => {
                    return <PrescriptionItem prescription={prescription} partialOffer={partial_offer_id} key={index}  price={prices.find(item => item.id === prescription.order_item_id)} />
                })
            }
            {/*{
                products.map((product, index) => {
                    return <ProductItem {...product} key={index} price={prices.find(item => item.id === product.order_item_id)}/>
                })
            }*/}
        </div>
    )
}

export default PharmacyOrderItemsList;